import React from "react";
import { wooCategory } from "../../lib/interfaces";
import { cn, decodeHTML } from "../../lib/utils";
import { WooCommerce } from "../../lib/api";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "../../components/ui/navigation-menu";
import { useQuery } from "react-query";
import { Link, useNavigate } from "react-router-dom";
import { amadeusServices } from "../services/priceList";
export default function NewCategoriesBar({
  scrolled,
}: {
  scrolled: boolean;
}) {
  const { data: categories } = useQuery(
    ["wooCategories"],
    async () => {
      const res: wooCategory[] = WooCommerce.get(
        "products/categories/?per_page=100"
      )
        .then((response: any) => {
          return response.data;
        })
        .catch((error: any) => {
          console.log(error.response.data);
        });
      return res;
    }
  );
  const nav = useNavigate();
  const ListItem = React.forwardRef<
    React.ElementRef<"a">,
    React.ComponentPropsWithoutRef<"a">
  >(({ className, title, children, ...props }, ref) => {
    return (
      <li>
        <NavigationMenuLink asChild>
          <a
            ref={ref}
            className={cn(
              "block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground",
              className
            )}
            {...props}
          >
            <div className="text-sm font-medium leading-none">
              {title}
            </div>
            <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
              {children}
            </p>
          </a>
        </NavigationMenuLink>
      </li>
    );
  });
  ListItem.displayName = "ListItem";
  return (
    <NavigationMenu
      className={scrolled ? "" : "opacity-90"}
    >
      <NavigationMenuList className="w-screen flex-wrap gap-5 flex justify-center items-center ">
        <NavigationMenuItem>
          <NavigationMenuTrigger
            onClick={() => nav("/shop/category/486/BRANDS")}
            className={
              scrolled
                ? "dark:text-neutral-200 text-neutral-900 data-[state=open]:bg-transparent data-[state=closed]:bg-transparent hover:text-neutral-400 p-0"
                : "dark:text-neutral-900 text-neutral-900 data-[state=open]:bg-transparent data-[state=closed]:bg-transparent hover:text-neutral-800 p-0"
            }
          >
            BRANDS
          </NavigationMenuTrigger>
          <NavigationMenuContent
            className={
              "dark:bg-neutral-900 bg-white dark:text-neutral-100 z-50 border-0 h-[500px] NavigationMenuContent pt-10 menuBar"
            }
          >
            <div className="text-light text-sm w-screen flex gap-x-10 gap-2 p-5 w-full justify-start items-start">
              {categories
                ?.filter(
                  (category) =>
                    category.id === 368 ||
                    category.id === 502 ||
                    category.id === 505
                )
                .map((category) => (
                  <div
                    key={category.id}
                    className="border-l border-neutral-300 pl-3 h-full flex flex-col gap-2"
                  >
                    <NavigationMenuLink asChild>
                      <Link
                        to={`/shop/category/${category.id}/${category.slug}`}
                        className="font-medium"
                      >
                        {decodeHTML(category.name)}
                      </Link>
                    </NavigationMenuLink>
                    <div className="flex flex-col gap-1 pl-2">
                      {categories
                        ?.filter(
                          (cat) =>
                            cat.parent === category.id
                        )
                        .map((category) => (
                          <NavigationMenuLink
                            asChild
                            key={category.id}
                          >
                            <Link
                              to={`/shop/category/${category.id}/${category.slug}`}
                              className="font-light hover:underline"
                            >
                              {decodeHTML(category.name)}
                            </Link>
                          </NavigationMenuLink>
                        ))}
                    </div>
                  </div>
                ))}
            </div>
          </NavigationMenuContent>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <NavigationMenuTrigger
            onClick={() =>
              nav("/shop/category/17/Hair Care")
            }
            className={
              scrolled
                ? "dark:text-neutral-200 text-neutral-900  data-[state=open]:bg-transparent data-[state=closed]:bg-transparent hover:text-neutral-400 p-0"
                : "dark:text-neutral-900 text-neutral-900  data-[state=open]:bg-transparent data-[state=closed]:bg-transparent hover:text-neutral-800 p-0"
            }
          >
            HAIR CARE
          </NavigationMenuTrigger>
          <NavigationMenuContent
            className={
              "dark:bg-neutral-900 bg-white dark:text-neutral-100 z-50 border-0 h-[500px] NavigationMenuContent pt-10"
            }
          >
            <div className="text-light text-sm w-screen flex gap-x-10 gap-2 p-5 w-full justify-start items-start">
              {categories
                ?.filter(
                  (category) => category.parent === 17
                )
                .map((category) => (
                  <div
                    key={category.id}
                    className="border-l border-neutral-300 pl-3 h-full flex flex-col gap-2"
                  >
                    <NavigationMenuLink
                      className="font-medium"
                      asChild
                    >
                      <Link
                        to={`/shop/category/${category.id}/${category.slug}`}
                      >
                        {decodeHTML(category.name)}
                      </Link>
                    </NavigationMenuLink>
                    <div className="flex flex-col gap-1 pl-2">
                      {categories
                        ?.filter(
                          (cat) =>
                            cat.parent === category.id
                        )
                        .map((category) => (
                          <NavigationMenuLink
                            asChild
                            key={category.id}
                          >
                            <Link
                              to={`/shop/category/${category.id}/${category.slug}`}
                              className="font-light"
                            >
                              {decodeHTML(category.name)
                                .charAt(0)
                                .toUpperCase() +
                                String(
                                  decodeHTML(category.name)
                                )
                                  .slice(1)
                                  .toLocaleLowerCase()}
                            </Link>
                          </NavigationMenuLink>
                        ))}
                    </div>
                  </div>
                ))}
            </div>
          </NavigationMenuContent>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <NavigationMenuTrigger
            onClick={() => nav("/services")}
            className={
              scrolled
                ? "dark:text-neutral-200 text-neutral-900  data-[state=open]:bg-transparent data-[state=closed]:bg-transparent hover:text-neutral-400 p-0"
                : "dark:text-neutral-900 text-neutral-900  data-[state=open]:bg-transparent data-[state=closed]:bg-transparent hover:text-neutral-800 p-0"
            }
          >
            SERVICES
          </NavigationMenuTrigger>
          <NavigationMenuContent
            className={
              "dark:bg-neutral-900 bg-white dark:text-neutral-100 z-50 border-0 h-[500px] pt-10"
            }
          >
            <div className="text-light text-sm w-screen flex gap-x-5 gap-2 p-5 w-full justify-center items-start">
              {amadeusServices?.map((i: any) => (
                <NavigationMenuLink
                  asChild
                  className="relative w-full cursor-pointer"
                  key={i.id}
                  onClick={() => nav(i.link)}
                >
                  <Link to={i.link}>
                    <img
                      src={i.image}
                      alt="carousel-img"
                      className="w-full"
                    />

                    <p
                      className={`flex justify-center items-end absolute bottom-0 pb-2 text-xl w-full text-white text-center h-1/3 bg-gradient-to-t from-neutral-900 `}
                    >
                      <span> {i.service}</span>
                    </p>
                  </Link>
                </NavigationMenuLink>
              ))}
            </div>
          </NavigationMenuContent>
        </NavigationMenuItem>
        {/* <NavigationMenuItem>
          <NavigationMenuTrigger
            onClick={() =>
              nav("/shop/category/484/jewellery")
            }
            className={
              scrolled
                ? "dark:text-neutral-200 text-neutral-900  data-[state=open]:bg-transparent data-[state=closed]:bg-transparent hover:text-neutral-400 p-0"
                : "dark:text-neutral-900 text-neutral-900  data-[state=open]:bg-transparent data-[state=closed]:bg-transparent hover:text-neutral-800 p-0"
            }
          >
            JEWELLERY
          </NavigationMenuTrigger>
          <NavigationMenuContent
            className={
              "dark:bg-neutral-900 bg-white dark:text-neutral-100 z-50 border-0  h-[500px] pt-10"
            }
          >
            <div className="w-screen flex gap-x-10 gap-2 p-5 flex-wrap w-full justify-start items-start">
              {categories
                ?.filter(
                  (category: any) => category.parent === 484
                )
                .map((category: any, index: any) => (
                  <Link
                    onMouseOver={() =>
                      handleMouseOver(index, category.id)
                    }
                    onMouseOut={handleMouseOut}
                    to={`/shop/category/${
                      category.id
                    }/${decodeHTML(category.name)}`}
                    key={category.id}
                    className="relative w-1/4 flex gap-1 items-center text-[12px] font-light"
                  >
                    <img
                      src={category.image.src}
                      alt=""
                      className=" w-full"
                    />
                    <span
                      className={`text-center pt-2 text-xl absolute bottom-0 w-full h-1/4 from-neutral-400 w-full bg-gradient-to-t ${
                        (index === hoveredIndex) ===
                          index && isHovered
                          ? ""
                          : ""
                      }`}
                    >
                      {decodeHTML(
                        category.name
                      ).toLocaleUpperCase()}
                    </span>
                  </Link>
                ))}
            </div>
          </NavigationMenuContent>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <NavigationMenuTrigger
            onClick={() =>
              nav("/shop/category/505/Accessories")
            }
            className={
              scrolled
                ? "dark:text-neutral-200 text-neutral-900  data-[state=open]:bg-transparent data-[state=closed]:bg-transparent hover:text-neutral-400 p-0"
                : "dark:text-neutral-900 text-neutral-900  data-[state=open]:bg-transparent data-[state=closed]:bg-transparent hover:text-neutral-800 p-0"
            }
          >
            ACCESSORIES
          </NavigationMenuTrigger>
          <NavigationMenuContent
            className={
              "dark:bg-neutral-900 bg-white dark:text-neutral-100 z-50 border-0  h-[500px] pt-10"
            }
          >
            <div className="text-light text-sm w-screen flex gap-x-10 gap-2 p-5 w-full justify-start items-start">
              {categories
                ?.filter(
                  (category) => category.parent === 505
                )
                .map((category) => (
                  <div
                    key={category.id}
                    className="border-l border-neutral-300 pl-2 h-full"
                  >
                    <Link
                      to={`/shop/category/${category.id}/${category.slug}`}
                      className="font-medium"
                    >
                      {decodeHTML(category.name)}
                    </Link>
                    <div className="flex flex-col gap-1 mt-5 pl-1">
                      {categories
                        ?.filter(
                          (cat) =>
                            cat.parent === category.id
                        )
                        .map((category) => (
                          <Link
                            key={category.id}
                            to={`/shop/category/${category.id}/${category.slug}`}
                            className="font-light"
                          >
                            {decodeHTML(category.name)}
                          </Link>
                        ))}
                    </div>
                  </div>
                ))}
            </div>
          </NavigationMenuContent>
        </NavigationMenuItem> */}
        {/* <NavigationMenuItem>
          <NavigationMenuTrigger
            className={
              scrolled
                ? "dark:text-neutral-200 text-neutral-900  data-[state=open]:bg-transparent data-[state=closed]:bg-transparent hover:text-neutral-400 p-0"
                : "dark:text-neutral-900 text-neutral-900  data-[state=open]:bg-transparent data-[state=closed]:bg-transparent hover:text-neutral-800 p-0"
            }
          >
            GIFT CARDS
          </NavigationMenuTrigger>
          <NavigationMenuContent
            className={
              "dark:bg-neutral-900 bg-white dark:text-neutral-100 z-50 border-0  h-[500px]"
            }
          ></NavigationMenuContent>
        </NavigationMenuItem> */}
        <Link
          key={"careers"}
          to={`/careers`}
          className={
            scrolled
              ? "text-sm font-medium dark:text-neutral-100"
              : "text-sm font-medium dark:text-neutral-900"
          }
        >
          CAREERS
        </Link>
        <Link
          key={"contact"}
          to={`/contact`}
          className={
            scrolled
              ? "text-sm font-medium dark:text-neutral-100"
              : "text-sm font-medium dark:text-neutral-900"
          }
        >
          CONTACT
        </Link>
      </NavigationMenuList>
    </NavigationMenu>
  );
}
